/**
 * Created by mac on 7/23/18
 */

const Competition = function (options) {
    cleverapps.EventEmitter.call(this);

    this.type = options.type;
    this.options = options;

    let data = undefined;

    if (options.store) {
        data = cleverapps.dataLoader.load(`${DataLoader.TYPES.COMPETITION}_${this.type}`);
        cleverapps.dataLoader.remove(DataLoader.TYPES.COMPETITION);
    }

    this.outcome = Competition.OUTCOME_NONE;

    if (data) {
        this.results = data.results;
        options.algo = { ...options.algo, ...data.algorithm };
    } else if (options.players) {
        this.results = options.players;
    } else {
        this.results = cleverapps.bots.listBots(options.amount);
        this.results.forEach((bot) => {
            bot.amount = 0;
        });
    }

    this.player = this.getPlayerById(Competition.PLAYER_ID);
    // migrate//
    this.results.forEach((result) => {
        if (result.id === connector.platform.getUserID()) {
            if (!this.player) {
                result.id = Competition.PLAYER_ID;
                this.player = result;
            }
        }
    });

    this.results = this.results.filter(
        (r) => r.id !== connector.platform.getUserID()
    );

    if (!this.player) {
        this.player = {
            player: true,
            id: Competition.PLAYER_ID,
            name: cleverapps.user.getPlayerInfo().name,
            amount: 0
        };

        this.results.push(this.player);
    }

    this.player.avatar = cleverapps.user.getPlayerInfo().avatar;

    if (options.playerResult !== undefined) {
        this.player.amount = options.playerResult;
    }

    if (this.results.length > options.amount + 1) {
        for (let i = this.results.length - 1; i >= 0 && this.results.length > options.amount + 1; i--) {
            if (!this.results[i].player) {
                this.results.splice(i, 1);
            }
        }
    }

    this.running = true;

    this.onChangeResultsListeners = {};

    this.onChangePlaceListener = function () {};

    this.updateShownPlace();

    const Algorithm = this.options.algo.algo || CompetitionAlgorithm;

    this.algorithm = new Algorithm(this, this.options.algo);
    
    cleverapps.bots.on("updateBotInfo", this.onEditProfile.bind(this), this);

    this.checkOutcome();

    if (options.withScrollTable) {
        this.table = new ScrollTable(new CompetitionDataSource(this));
    }

    this.onGetOpponent = function () {};
    this.onGetUserView = function () {};
};

Competition.prototype = Object.create(cleverapps.EventEmitter.prototype);
Competition.prototype.constructor = Competition;

Competition.prototype.start = function () {
    this.algorithm.start();
};

Competition.optionsForKnockoutGame = function (game) {
    let averageProcessTimeout = 10;
    if (cleverapps.config.type === "board") {
        averageProcessTimeout = cleverapps.competitionStatistics.getBoardGameWordOpenByKeypadLengthTime(game.keypad.amountKeys());
    } else if (cleverapps.config.type === "differences") {
        averageProcessTimeout = cleverapps.competitionStatistics.getOneDifferenceFindTime();
    }

    const rumble = cleverapps.knockoutGame.rumble;
    const opponent = rumble.getCurrentRound().getOpponent(Competition.PLAYER_ID);

    const botForces = [0.6, 0.8, 1];
    opponent.force = botForces[rumble.rounds.length - 1];
    opponent.amount = 0;

    const savedData = cleverapps.dataLoader.load(`${DataLoader.TYPES.COMPETITION}_knockout`);
    if (savedData) {
        opponent.savedPoints = savedData;
        opponent.amount = savedData.length;
    }

    let botAheadPlayerCoef = 0.3;
    let playerAheadBotCoef = 1.5;
    let botFinishCoef = 0.5;
    const playerAheadBotBigDifferenceCoef = 2;
    const botAheadPlayerBigDifferenceCoef = 0.5;

    switch (cleverapps.knockoutGame.calcTournamentType()) {
        case KnockoutGame.BOT_CANNOT_WIN_TOURNAMENT:
            botFinishCoef = 0;
            playerAheadBotCoef = 2;
            averageProcessTimeout = Math.floor(averageProcessTimeout * 0.8);
            break;
        case KnockoutGame.VERY_EASY_TOURNAMENT:
            botAheadPlayerCoef = 0.3;
            playerAheadBotCoef = 2;
            averageProcessTimeout = Math.floor(averageProcessTimeout * 2.5);
            break;
        case KnockoutGame.EASY_TOURNAMENT:
            botAheadPlayerCoef = 0.4;
            playerAheadBotCoef = 1;
            botFinishCoef = 0.3;
            averageProcessTimeout = Math.floor(averageProcessTimeout * 1.3);
            break;
        case KnockoutGame.NORMAL_TOURNAMENT:
            botAheadPlayerCoef = 0.5;
            playerAheadBotCoef = 1.2;
            botFinishCoef = 0.3;
            averageProcessTimeout = Math.floor(averageProcessTimeout * 1.1);
            break;
        case KnockoutGame.DIFFICULT_TOURNAMENT:
            botAheadPlayerCoef = 0.6;
            playerAheadBotCoef = 1.5;
            averageProcessTimeout = Math.floor(averageProcessTimeout * 0.8);
            break;
        case KnockoutGame.VERY_DIFFICULT_TOURNAMENT:
            botAheadPlayerCoef = 0.8;
            playerAheadBotCoef = 1.5;
            averageProcessTimeout = Math.floor(averageProcessTimeout * 0.5);
            break;
    }

    return {
        type: "knockout",
        amount: 1,

        players: [opponent],

        algo: {
            noPlayerEpisodeCoef: true,
            averageProcessTimeout: cleverapps.parseInterval(`${averageProcessTimeout} seconds`),
            botAheadPlayerCoef,
            botAheadPlayerBigDifferenceCoef,
            playerAheadBotCoef,
            playerAheadBotBigDifferenceCoef,
            bigDistanceLength: 1,
            offlineProcess: false,
            useRealForce: true,
            duration: cleverapps.parseInterval("3 hour"),
            maxResult: game.totalItemsToSolve(),
            botFinishCoef
        }
    };
};

Competition.prototype.calcPlace = function () {
    this.results.sort((a, b) => {
        if (b.amount !== a.amount) {
            return b.amount - a.amount;
        }
        if (this.type === "tournament" && a.event && b.event && a.event !== b.event) {
            return a.event - b.event;
        }
        if (a === this.player) {
            return -1;
        }
        if (b === this.player) {
            return 1;
        }
        return 0;
    });

    return this.results.indexOf(this.player);
};

Competition.prototype.updatePlayerResult = function (id, amount) {
    if (this.options.oneWinner && this.outcome !== Competition.OUTCOME_NONE) {
        return;
    }

    if (this.options.algo.maxResult && amount > this.options.algo.maxResult) {
        amount = this.options.algo.maxResult;
    }

    for (let i = 0; i < this.results.length; i++) {
        if (this.results[i].id === id && this.results[i].amount !== amount) {
            amount = amount || 0;
            
            this.results[i].amount = amount;
            this.results[i].event = Date.now();
            this.runChangeResultsListeners(id);
            break;
        }
    }
    if (this.hasPlaceChanged()) {
        this.onChangePlaceListener();
    }

    this.checkOutcome();
};

Competition.prototype.checkOutcome = function () {
    const finishedOpponents = this.getFinishedOpponents().length;
    if (finishedOpponents === this.options.amount && this.options.lose !== false && !this.options.oneWinner) {
        this.trigger("lose");
    }

    if (this.options.oneWinner) {
        if (this.player.amount >= this.options.algo.maxResult) {
            this.setOutcome(Competition.OUTCOME_VICTORY);
        } else if (this.getFinishedOpponents().length > 0) {
            this.setOutcome(Competition.OUTCOME_LOST);
        }
    }
};

Competition.prototype.getOutcome = function () {
    return this.outcome;
};

Competition.prototype.setOutcome = function (outcome) {
    if (this.outcome === outcome) {
        return;
    }

    this.outcome = outcome;
    this.trigger("outcome", outcome);
};

Competition.prototype.hasPlaceChanged = function () {
    if (!this.lastShownPlace) {
        this.lastShownPlace = this.calcPlace();
        return false;
    }

    return this.lastShownPlace !== this.calcPlace();
};

Competition.prototype.updateShownPlace = function () {
    this.lastShownPlace = this.calcPlace();
};

Competition.prototype.getFinishedOpponents = function () {
    return this.results.filter((result) => result.id !== Competition.PLAYER_ID && result.amount === this.options.algo.maxResult);
};

Competition.prototype.runChangeResultsListeners = function (id) {
    Object.values(this.onChangeResultsListeners).forEach((listener) => {
        listener(id);
    });
};

Competition.prototype.stop = function () {
    this.running = false;
    this.onChangePlaceListener = function () {};
    this.onChangeResultsListeners = {};

    runCleaners(this);

    this.algorithm.stop();

    if (this.table) {
        this.table.destructor();
    }
};

// TODO: clean always on .start() except constuctor
Competition.CLEAN_SAVED = function (type) {
    cleverapps.dataLoader.remove(`${DataLoader.TYPES.COMPETITION}_${type}`);
};

Competition.prototype.getPlayerById = function (id) {
    return this.results.filter((result) => result.id === id)[0];
};

Competition.prototype.getDisplayedResults = function () {
    if (!this._displayedResults) {
        this._displayedResults = this.getResults({ sortByName: true });
    }

    return this._displayedResults;
};

Competition.prototype.getDisplayedResultById = function (id) {
    return this.getDisplayedResults().filter((result) => result.id === id)[0];
};

Competition.prototype.updateDisplayedResults = function () {
    this._displayedResults = this.getResults({ sortByName: true });
};

Competition.prototype.getResults = function ({ sortByName } = {}) {
    const results = this.results.map((result) => ({ ...result }));

    const compareFnByName = (a, b) => {
        const pm = (b.player ? 1 : 0) - (a.player ? 1 : 0);
        if (pm !== 0) {
            return pm;
        }

        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return nameA.localeCompare(nameB, undefined, { numeric: true });
    };

    results.sort((a, b) => {
        const diff = b.amount - a.amount;
        if (diff !== 0) {
            return diff;
        }

        return compareFnByName(a, b);
    });

    results.forEach((result, index) => {
        result.place = index + 1;
    });

    if (sortByName) {
        results.sort(compareFnByName);
    }

    return results;
};

Competition.prototype.save = function () {
    if (!this.options.store) {
        return;
    }

    const results = this.results.map((result) => {
        if (typeof result.avatar !== "string") {
            result = { ...result, avatar: undefined };
        }
        return result;
    });

    cleverapps.dataLoader.save(`${DataLoader.TYPES.COMPETITION}_${this.type}`, {
        results,
        algorithm: this.algorithm.getData(),
        level: this.options.level ? this.options.level.getHumanReadableNumber() : undefined
    });
};

Competition.prototype.onEditProfile = function (playerInfo) {
    if (playerInfo.id === connector.platform.getUserID()) {
        playerInfo.id = Competition.PLAYER_ID;
    }

    const player = this.getPlayerById(playerInfo.id);
    if (player) {
        player.name = playerInfo.name;
        player.avatar = playerInfo.avatar;
        delete player.fake;
    }

    this.save();

    if (this.table) {
        this.table.updateAll(true);
    }
};

Competition.PLAYER_ID = "12345";

Competition.OUTCOME_NONE = undefined;
Competition.OUTCOME_LOST = 0;
Competition.OUTCOME_VICTORY = 1;